import "./home.less";

import { Invoice } from '../../Components/invoice/invoice.component';

const HomePage = () => {
  return <Invoice />;
};

export default HomePage;